<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.75" y="0.75" width="26.5" height="26.5" rx="13.25" fill="var(--bg-color)" stroke="var(--icon-color)" stroke-width="1.5" />
    <path d="M10.5 11L10.5 20M10.5 20L14.5 16M10.5 20L6.5 16" stroke="var(--icon-color)" stroke-width="1.5" />
    <path d="M17.5 17V8M17.5 8L13.5 12M17.5 8L21.5 12" stroke="var(--icon-color)" stroke-width="1.5" />
</svg>
